module.exports = __webpack_public_path__ + "static/media/clienticon.0cd2c007.svg";